<template>
    <div class="qkxx fifth" v-if="CommentList">
                    <form class="form-horizontal fifth" ref='from'>
                      <div class="advice_text"><strong>发表评论</strong></div>
                      <div class="ten">
                        <span>当前用户：{{NickyName}}</span>
                        <span class="ml15">
                          <el-checkbox v-model="checked">匿名发表</el-checkbox>
                        </span>
                      </div>
                      <div class="form-group">
                        <div class="col-sm-12 ten">
                          <el-form ref="form" >
                            <el-form-item>
                              <el-input type="textarea" placeholder="请输入评论内容" :rows="5" v-model="commentText"></el-input>
                              <el-button type="primary" @click="publishComment(commentText)" class="ten">发表评论</el-button>
                            </el-form-item>
                          </el-form>
                        </div>
                      </div>
                    </form>
                    <div class="advice_text">全部评论共<strong class="red">{{comms==0?comm:comms}}</strong>条评论，
                      <el-button type="primary" v-if="CommentList.length>2"  @click="tocom($event,id)">查看评论</el-button>
                      <span class="red ml5" style=" font-size: 13px;" v-show="Token==''">用户登录后即可发表评论。</span>
                    </div>
                    <div class="media advice_list" v-if="CommentList.length>0">
                      <div class="media-body fifth" v-for="(item,index) in CommentLists.length<1?CommentList:CommentLists"  :key="index">
                        <div class="media-heading" >
                          <span v-if="item.IfNickyName== true">匿名发表</span>
                          <span v-else>{{item.CommentatorName}}</span>
                          <span class="media-date">{{item.DateCreate}}</span>
                          </div>
                        <div class="five">{{item.Comment}}</div>
                      </div>
                    </div>
                  </div>
</template>
<script>
export default {
    data(){
        return{
             commentText: '', // 评论内容
             NickyName:'',
             checked:false,
             commentText:'',
             Token: '',
             CommentLists:'',
             comms:0
        }
    },
    props:['comm','CommentList'],
    mounted(){
        this.id=this.$route.query.ArticleID?this.$route.query.ArticleID:this.$route.query.ItemId;
        var a = localStorage.getItem("userInfo")
      if (a != null) {
        this.Token = JSON.parse(a).Token
        this.NickyName = JSON.parse(a).UserName
      }
    },
    methods:{
        
       publishComment(e) {
        this._postMassage()
        this._getPLLB(this.id)
      },
      _postMassage() {
        var id = parseInt(this.id)
        var Text = this.commentText
        var Ip = returnCitySN['cip']
        var title = this.Title
        var name = this.checked
        if(this.Token==''){
          alert("只有登录用户才能发表评论");
          return
        }
        let params = {
          Token: this.Token,
          Kind: 2,
          ID: id,
          IfNickyName: name,
          Comments: Text,
          IpAddress: Ip,
          Title: title
        }
        var a = sessionStorage.getItem('aa')
        if (a == 1) {
          params.Kind = 4
        } else {
          params.Kind = 2
        }
        this.$store.dispatch("_postMassage",params)
        .then(res => {
          if (res.data.IsSuccess) {
            alert("发表成功")
            var cc = this.checked
            sessionStorage.setItem('cc', cc)
            this._getPLLB()
            this.commentText = ''
          }
        }).catch(err => {
          alert(res.data.Message)
          console.log("err", err)
        })
      },
      _getPLLB(id){
        var id = id
        let params = {
          Type: 2,
          ID: id,
          PageSize: 3
        }
        var a = sessionStorage.getItem('aa')
        if (a == 1) {
          params.Type = 4
        } else {
          params.Type = 2
        }
         this.$store.dispatch("_getPLLB",params)
        .then(res => {
          if (res.data.IsSuccess) {
            this.CommentLists = res.data.Data
            this.comms = res.data.ItemCount
            window.location.reload()
          }
        }).catch(err => {
          console.log("err", err)
        })
      },
      tocom(e, id) {
        e.preventDefault()
        this.$router.push({
          path: '/comments?ArticleID=' + id
        })
      },
    }
}
</script>